import { Link } from "react-router-dom";
import { Header } from "@/components/Header";
import { Footer } from "@/components/Footer";

export const Layout = ({ children }) => (
  <div className="bliss-page">
    <Header />
    <main>{children}</main>
    <Footer />
  </div>
);

export const Breadcrumbs = ({ trail }) => (
  <nav className="bliss-breadcrumbs" aria-label="Breadcrumb" data-testid="breadcrumbs">
    {trail.map((r, i) => (
      <span key={r.path}>
        {i > 0 && <span className="bliss-crumb-sep" aria-hidden="true">/</span>}
        {i === trail.length - 1 ? (
          <span aria-current="page">{r.path === "/" ? "Home" : r.nav || r.h1}</span>
        ) : (
          <Link to={r.path}>{r.path === "/" ? "Home" : r.nav || r.h1}</Link>
        )}
      </span>
    ))}
  </nav>
);
